import BaseObjectStore from './base-object.store';

class WorkoutAssignmentStatusStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'workoutAssignmentStatus';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new WorkoutAssignmentStatusStore();
